import { useBooleanState, useQueryParams } from '@calendly/hooks';
import { useState } from 'react';
import { FilterModal } from './filter_modal';
import { FilterButton } from '../../shared/filters/filter_button';
import { countNonDefaultFilters } from '../../shared/filters/helpers';
const buttonWithModalWrapperCss = "b1c46bdw";
export const Filter = () => {
  const queryParams = useQueryParams();
  const [isModalOpen, openModal, closeModal] = useBooleanState(false);
  const [appliedFiltersCount, setAppliedFiltersCount] = useState(countNonDefaultFilters(queryParams));
  return <div className={buttonWithModalWrapperCss}>
      <FilterButton isModalOpen={isModalOpen} openModal={openModal} closeModal={closeModal} appliedFiltersCount={appliedFiltersCount} />
      <FilterModal isOpen={isModalOpen} onClose={closeModal} setAppliedFiltersCount={setAppliedFiltersCount} />
    </div>;
};

require("./filter.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter.js");